import React from "react";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";
import { OriAvatar } from "components/ori";
import { OriConversationStarter } from "apps/user/learner/lib/oriConversationStarters";

import styles from "./ori-conversation-starter.module.scss";

interface OriConversationStarterBannerProps {
  starter: OriConversationStarter | null;
  onTellMeMore: () => void;
}

const OriConversationStarterBanner: React.FC<
  OriConversationStarterBannerProps
> = ({ starter, onTellMeMore }) => {
  const { t } = useTranslation(["home"]);

  if (!starter) return null;

  return (
    <div
      className={styles["starter-card"]}
      data-testid="ori-conversation-starter"
    >
      <div className={styles["starter-avatar"]} aria-hidden>
        <OriAvatar size={56} />
      </div>
      <div className={styles["starter-body"]}>
        <span className={styles["starter-title"]}>{t("home:starter.title")}</span>
        <p className={styles["starter-hook"]}>{starter.hook}</p>
        <Button
          variant="enclosed-primary"
          monochromeColour="black"
          className={styles["starter-cta"]}
          onClick={onTellMeMore}
          data-testid="ori-conversation-starter-cta"
        >
          {t("home:starter.tellMeMore")}
        </Button>
      </div>
    </div>
  );
};

export default OriConversationStarterBanner;
